import React, { Component } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../../../utils/withRouter";
import Loader from "../../../../utils/Loader";
// import { clearSessionStorage } from '../../../utils/constants'
import Header from "../../../../common_components/Header";
// import { emailValidator } from '../../../utils/Validator'
import Modal from "react-modal";
import Footerwithdr from "../../../../common_components/Footerwithdr";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { fill_action } from "../../../../actions/fillCombo_action";
// import ReceiptList from '../registration_receipt/ReceiptList';
import { Link } from "react-router-dom";
import { getAdminApplicationSummaryList_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_summary_action/admin_dashboard_summary_action";
import { getAdminDashboardData_action } from "../../../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_action";
import { data } from "jquery";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
class ApplicationSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      applicationSummaryList: [],
      pendingPaymentCount: "",
    };
    this.record = this.record.bind(this);
    this.getDashboardData = this.getDashboardData.bind(this);
    this.navToPaymentList = this.navToPaymentList.bind(this);
    this.getApplicationSummaryList = this.getApplicationSummaryList.bind(this);
    this.onCountClick = this.onCountClick.bind(this);
  }

  // On Component Load
  componentDidMount() {
    this.getDashboardData();
    this.getApplicationSummaryList();
  }

  // Get DashBoard Data
  getDashboardData() {
    this.setState({ isLoading: true });
    this.props
      .getAdminDashboardData_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("Admin Dashboard Data ------->", data.data);
          this.setState({
            isLoading: false,
            pendingPaymentCount: data.data[0]["Count_Of_Payment"],
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Get summary list
  getApplicationSummaryList() {
    this.setState({ isLoading: true });
    this.props
      .getAdminApplicationSummaryList_action()
      .then((data) => {
        if (data.error != 1) {
          // Sort rows with halls alphabetically by HallNames; rows without halls go after
          const withHalls = data.data
            .filter((item) => item.HallNames && item.HallNames !== "")
            .sort((a, b) => a.HallNames.localeCompare(b.HallNames));
          const withoutHalls = data.data.filter(
            (item) => !item.HallNames || item.HallNames === "",
          );
          const sortedData = [...withHalls, ...withoutHalls];

          const hallresult = sortedData.map((item, index) => {
            if (item.HallNames == null || item.HallNames === "") {
              return {
                ...item,
                rowspan: 1,
                totalSalebleArea: item.SalebleArea ?? 0,
                totalGrossArea: item.GrossArea ?? 0,
                totalBalanceArea: item.BalanceArea ?? 0,
              };
            }

            // Non-first row of a group: skip merged cells
            if (
              index > 0 &&
              sortedData[index - 1].HallNames === item.HallNames
            ) {
              let start = index;
              while (
                start > 0 &&
                sortedData[start - 1].HallNames === item.HallNames
              ) {
                start--;
              }

              let totalSalebleArea = 0;
              let totalGrossArea = 0;
              let totalBalanceArea = 0;
              let k = start;
              while (
                k < sortedData.length &&
                sortedData[k].HallNames === item.HallNames
              ) {
                totalSalebleArea += sortedData[k].SalebleArea || 0;
                totalGrossArea += sortedData[k].GrossArea || 0;
                totalBalanceArea += sortedData[k].BalanceArea || 0;
                k++;
              }

              return {
                ...item,
                rowspan: 0,
                totalSalebleArea,
                totalGrossArea,
                totalBalanceArea,
              };
            }

            // First row of a group: compute rowspan and group totals
            let rowspan = 1;
            let totalSalebleArea = item.SalebleArea || 0;
            let totalGrossArea = item.GrossArea || 0;
            let totalBalanceArea = item.BalanceArea || 0;
            let j = index + 1;
            while (
              j < sortedData.length &&
              sortedData[j].HallNames === item.HallNames
            ) {
              totalSalebleArea += sortedData[j].SalebleArea || 0;
              totalGrossArea += sortedData[j].GrossArea || 0;
              totalBalanceArea += sortedData[j].BalanceArea || 0;
              rowspan++;
              j++;
            }

            return {
              ...item,
              rowspan,
              totalSalebleArea,
              totalGrossArea,
              totalBalanceArea,
            };
          });

          // Totals are based only on what is visible in the grid.
          // Gross / Salable / Balance are rendered with rowSpan, so a clubbed
          // group shows a single value and must be counted once (rowspan != 0).
          // Applied / Incomplete columns are printed on every row, so all rows count.
          var temptotalGross = 0;
          var temptotalSalable = 0;
          var temptotalAppliedExhCount = 0;
          var temptotalAppliedArea = 0;
          var temptotalIncompleteExhCount = 0;
          var temptotalIncompleteArea = 0;
          var temptotalBalanceArea = 0;

          for (var i = 0; i < hallresult.length; i++) {
            if (hallresult[i].rowspan != 0) {
              temptotalGross += hallresult[i].GrossArea || 0;
              temptotalSalable += hallresult[i].SalebleArea || 0;
              temptotalBalanceArea += hallresult[i].BalanceArea || 0;
            }
            temptotalAppliedExhCount += hallresult[i].AppliedExibitorCount || 0;
            temptotalAppliedArea += hallresult[i].AppliedArea || 0;
            temptotalIncompleteExhCount +=
              hallresult[i].IncompleteExibitorCount || 0;
            temptotalIncompleteArea += hallresult[i].IncompleteArea || 0;
          }

          // Append TOTAL row if not already present
          if (
            hallresult.length === 0 ||
            hallresult[hallresult.length - 1].ChapterName !== "TOTAL"
          ) {
            hallresult.push({
              ChapterName: "TOTAL",
              HallNames: "",
              GrossArea: temptotalGross,
              SalebleArea: temptotalSalable,
              AppliedExibitorCount: temptotalAppliedExhCount,
              AppliedArea: temptotalAppliedArea,
              IncompleteExibitorCount: temptotalIncompleteExhCount,
              IncompleteArea: temptotalIncompleteArea,
              BalanceArea: temptotalBalanceArea,
              rowspan: 1,
              totalGrossArea: temptotalGross,
              totalSalebleArea: temptotalSalable,
              totalBalanceArea: temptotalBalanceArea,
            });
          }

          this.setState({
            isLoading: false,
            applicationSummaryList: hallresult,
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  navToPaymentList() {
    this.props.navigate("/paymentlist");
  }

  onCountClick(chapterName, status) {
    console.log("Keyword------------>", `${chapterName.trim()}/${status}`);
    this.props.navigate("/exhibitorlist", {
      state: {
        fromDashBoard: true,
        keyword: `${chapterName.trim()}/${status}`,
        tab: "Application Summary",
      },
    });
  }

  record(list) {
    return (
      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
        <thead>
          <tr>
            <th className="text-center">Primary Segment</th>
            <th className="text-center">Hall</th>
            <th className="text-center">Gross Area(sqm)</th>
            <th className="text-center">Salable Area(sqm)</th>
            <th className="text-center" colspan="2">
              Applied
            </th>
            <th className="text-center">Balance Area (sqm)</th>
            <th className="text-center" colspan="2">
              Incomplete
            </th>
          </tr>
          <tr>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center"></th>
            <th className="text-center">Exhibitor Count</th>
            <th className="text-center">Area(sqm)</th>
            <th className="text-center"></th>
            <th className="text-center">Exhibitor Count</th>
            <th className="text-center">Area(sqm)</th>
          </tr>
        </thead>
        <tbody>
          {list.length > 0 ? (
            <>
              {list.map((data, i) => (
                <tr key={Math.random()}>
                  {/* <td className="text-center">
                                        {i === list.length - 1 ? (
                                            <strong>{data.ChapterName}</strong>
                                        ) : (
                                            <>
                                                {data.ChapterName}

                                                {data.HallNames && (
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id={`tooltip-${i}`}>
                                                                {data.HallNames}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <i
                                                            className="bi bi-info-circle ms-1"
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </OverlayTrigger>
                                                )}
                                            </>
                                        )}
                                    </td> */}
                  <td
                    className="text-center"
                    style={{ cursor: "pointer" }}
                    // onClick={(e) => this.onCountClick(data.ChapterName, "SaleableArea")}
                  >
                    {i == list.length - 1 ? (
                      <strong>{data.ChapterName}</strong>
                    ) : (
                      data.ChapterName
                    )}
                  </td>
                  {data.rowspan != 0 && (
                    <td
                      className="text-center"
                      rowSpan={data.rowspan}
                      style={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        cursor: "pointer",
                      }}
                      // onClick={(e) => this.onCountClick(data.ChapterName, "SaleableArea")}
                    >
                      {i == list.length - 1 ? (
                        <strong>{data.HallNames}</strong>
                      ) : (
                        data.HallNames
                      )}
                    </td>
                  )}
                  {data.rowspan != 0 && (
                    <td
                      className={
                        data.GrossArea < 0
                          ? "text-center text-danger"
                          : "text-center"
                      }
                      rowSpan={data.rowspan}
                      style={{ cursor: "pointer" }}
                      // onClick={(e) => this.onCountClick(data.ChapterName, "SaleableArea")}
                    >
                      {i == list.length - 1 ? (
                        <strong>{data.GrossArea}</strong>
                      ) : (
                        data.GrossArea
                      )}
                    </td>
                  )}
                  {data.rowspan != 0 && (
                    <td
                      className={
                        data.SalebleArea < 0
                          ? "text-center text-danger"
                          : "text-center"
                      }
                      rowSpan={data.rowspan}
                      style={{ cursor: "pointer" }}
                      // onClick={(e) => this.onCountClick(data.ChapterName, "SaleableArea")}
                    >
                      {i == list.length - 1 ? (
                        <strong>{data.SalebleArea}</strong>
                      ) : (
                        data.SalebleArea
                      )}
                    </td>
                  )}
                  <td
                    className={
                      data.AppliedExibitorCount < 0
                        ? "text-center text-danger"
                        : "text-center"
                    }
                    style={{ cursor: "pointer" }}
                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedExibitorCount")}
                  >
                    {i == list.length - 1 ? (
                      <strong>{data.AppliedExibitorCount}</strong>
                    ) : (
                      data.AppliedExibitorCount
                    )}
                  </td>
                  <td
                    className={
                      data.AppliedArea < 0
                        ? "text-center text-danger"
                        : "text-center"
                    }
                    style={{ cursor: "pointer" }}
                    // onClick={(e) => this.onCountClick(data.ChapterName, "AppliedArea")}
                  >
                    {i == list.length - 1 ? (
                      <strong>{data.AppliedArea}</strong>
                    ) : (
                      data.AppliedArea
                    )}
                  </td>
                  {data.rowspan != 0 && (
                    <td
                      className={
                        data.BalanceArea < 0
                          ? "text-center text-danger"
                          : "text-center"
                      }
                      rowSpan={data.rowspan}
                      style={{ cursor: "pointer" }}
                      // onClick={(e) => this.onCountClick(data.ChapterName, "BalanceArea")}
                    >
                      {i == list.length - 1 ? (
                        <strong>{data.BalanceArea}</strong>
                      ) : (
                        data.BalanceArea
                      )}
                    </td>
                  )}
                  <td
                    className={
                      data.IncompleteExibitorCount < 0
                        ? "text-center text-danger"
                        : "text-center"
                    }
                    style={{ cursor: "pointer" }}
                    // onClick={(e) => this.onCountClick(data.ChapterName, "IncompleteExibitorCount")}
                  >
                    {i == list.length - 1 ? (
                      <strong>{data.IncompleteExibitorCount}</strong>
                    ) : (
                      data.IncompleteExibitorCount
                    )}
                  </td>
                  <td
                    className={
                      data.IncompleteArea < 0
                        ? "text-center text-danger"
                        : "text-center"
                    }
                    style={{ cursor: "pointer" }}
                    // onClick={(e) => this.onCountClick(data.ChapterName, "IncompleteArea")}
                  >
                    {i == list.length - 1 ? (
                      <strong>{data.IncompleteArea}</strong>
                    ) : (
                      data.IncompleteArea
                    )}
                  </td>

                  {/* <td className="text-center" style={{ cursor: "pointer" }}
                                        onClick={(e) => this.onCountClick(data.ChapterName, "Alloted")}
                                    >{i == list.length - 1 ? <strong>{data.Alloted}</strong> : data.Alloted}</td> */}
                </tr>
              ))}
              {/* {list[list.length - 1].ChapterName != 'TOTAL' && <tr key={Math.random()}>
                                <td className="text-center"><strong>TOTAL</strong></td>
                                <td className="text-center"><strong>{this.state.totalApplied}</strong></td>
                                <td className="text-center"><strong>{this.state.totalAgent}</strong></td>
                                <td className="text-center"><strong>{this.state.totalWaiting}</strong></td>
                                <td className="text-center"><strong>{this.state.totalIncomplete}</strong></td>
                                <td className="text-center"><strong>{this.state.totalTotal}</strong></td>
                                <td className="text-center"><strong>{this.state.totalAlloted}</strong></td>
                            </tr>} */}
            </>
          ) : (
            <tr>
              <td colSpan={13} style={{ textAlign: "center" }}>
                Record not found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    const { isLoading, pendingPaymentCount, applicationSummaryList } =
      this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <>
          <AdminDrawer />
          <div className="admin-top-space">
            <div className="row mt-2 m-0">
              <div className="table-responsive mb-3 mt-2">
                {this.record(applicationSummaryList)}
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getAdminDashboardData_action,
    getAdminApplicationSummaryList_action,
  })(ApplicationSummary),
);
